import { CreateFinancialEntity } from "@project/domain/models/financial-entity/create-financial-entity.model";
import { FinancialEntityFormValuesValidated } from "@project/presentation/components/financial-entity-form/financial-entity-form.component";
import { injectable } from "inversify";
import { CreateFinancialEntityBody } from "../../dto/financial-entity/create-financial-entity.body";

@injectable()
export class CreateFinancialEntityMapper {
    mapFromFinancialEntityFormValues(
        financialEntityForm: FinancialEntityFormValuesValidated,
    ): CreateFinancialEntity {
        return new CreateFinancialEntity(
            financialEntityForm.name,
            financialEntityForm.type,
            financialEntityForm.description,
            financialEntityForm.isActive,
            financialEntityForm.entity,
            financialEntityForm.isShared,
            financialEntityForm.sharedWithEntities,
        );
    }

    mapToDto(
        createFinancialEntity: CreateFinancialEntity,
    ): CreateFinancialEntityBody {
        const body: CreateFinancialEntityBody = {
            name: createFinancialEntity.name,
            type: createFinancialEntity.type,
            description: createFinancialEntity.description,
            is_active: createFinancialEntity.isActive,
            entity: createFinancialEntity.entity ?? 0, // fallback seguro, ajusta según lógica de negocio
        };

        if (createFinancialEntity.isShared !== undefined) {
            body.is_shared = createFinancialEntity.isShared;
        }

        if (createFinancialEntity.sharedWithEntities !== undefined) {
            body.shared_with_entities = createFinancialEntity.sharedWithEntities;
        }

        return body;
    }
}
